window.addEventListener('DOMContentLoaded', function() {
    var spoilers = document.querySelectorAll('div.spoiler');
    
    spoilers.forEach(function(spoiler, index) {
        spoiler.querySelectorAll(':scope > br').forEach(function(br) {
            spoiler.removeChild(br);
        })
        
        var unfoldButton = createElement({
            name: 'span',
            classes: 'spoilerUnfoldButton'
        });
        unfoldButton.onclick = function() {
            spoiler.classList.toggle('open');
        }
        
        var head = createElement({
            name: 'div',
            classes: 'spoilerHead',
            childs: [
                unfoldButton,
                createElement({
                    name: 'span',
                    classes: 'spoilerTitle',
                    innerText: spoiler.getAttribute('data-title')
                })
            ]
        });
        
        var content = createElement({
            name: 'div',
            classes: 'spoilerContentWrapper',
            childs: [createElement({
                name: 'div',
                classes: 'spoilerContent',
                childs: spoiler.childNodes
            })]
        });
        
        spoiler.appendChild(head);
        spoiler.appendChild(content)
    });
});